<template>
  <div style="width: 100%">
    <h5>Letter</h5>
    <m-field label="Summary">{{ summary }}</m-field>
    <m-field label="Sender">{{ sender }}</m-field>
    <m-field label="Related to patient">{{ patient.label }}</m-field>

    <div class="inboundCommunications--inbound-letter--content">
      <div
        v-for="(page, pageIndex) in inboundLetterPages"
        :key="pageIndex"
        class="inboundCommunications--inbound-letter--content-page"
      >
        <details class="inboundCommunications--letter-accordion" open>
          <summary class="inboundCommunications--letter-accordion__summary">
            Letter {{ pageIndex + 1 }} content
          </summary>
          <p v-html="page.content"></p>
        </details>
      </div>
    </div>

    <div class="q-gutter-md row items-start">
      <img
        v-for="(page, pageIndex) in inboundLetterPages"
        :key="pageIndex"
        :src="inboundLetterPageBaseUrl + page.id"
        style="width: 150px; aspect-ratio: 1; object-fit: cover; border-radius: 4px"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import MField from "../../../MField";

export default {
  components: { MField },
  props: {
    summary: {
      type: String,
      default: "",
    },
    sender: {
      type: String,
      default: "",
    },
    patient: {
      type: Object,
      default: null,
    },
    inboundLetterPages: {
      type: Array,
      default: null,
    },
  },

  computed: {
    inboundLetterPageBaseUrl() {
      return this.$axios.defaults.baseURL + "patient/data/patient/view-inbound-letter/";
    },
  },
};
</script>
<style>
.inboundCommunications--inbound-letter--content {
  margin-top: 15px;
  margin-bottom: 30px;
}
.inboundCommunications--inbound-letter--content-page {
  margin-bottom: 15px;
}
.inboundCommunications--letter-accordion__summary {
  font-weight: bold;
  padding: 8px 0;
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  list-style: none;
}
.inboundCommunications--letter-accordion__summary::-webkit-details-marker {
  display: none;
}
</style>
